import { ReactNode } from 'react';

/**
 * @param children - The content to be wrapped by the PageBackgroundWrapper component, typically the main content of a page.
 * @param gapSize - An optional string that specifies the size of the gap between elements within the wrapper, allowing for flexible spacing based on design requirements.
 * @returns A JSX element that provides a consistent background and layout for the wrapped content, ensuring a cohesive look and feel across different pages of the application.
 *
 * The PageBackgroundWrapper component is designed to provide a consistent background and layout for the pages of the application. It centers its children both vertically and horizontally, and applies a specific background color and padding to create a cohesive look and feel across different pages. By using this wrapper, developers can ensure that all pages have a uniform appearance, enhancing the user experience and maintaining design consistency throughout the application.
 *
 **/
export const PageBackgroundWrapper = ({
  children,
  gapSize,
}: {
  children: ReactNode;
  gapSize?: string;
}) => {
  return (
    <div className="flex flex-1 justify-center items-center bg-bg-main py-space-700 px-space-500 max-h-full">
      <div
        className={`w-2xl h-auto p-space-500 flex flex-col justify-center rounded-radius-100 bg-bg-main-container ${gapSize ? 'gap-space-' + gapSize : ''}`}
      >
        {children}
      </div>
    </div>
  );
};
